import { useState } from "react";
import { toast } from "sonner";

export default function Newsletter() {
  const [email, setEmail] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (!email.trim() || !email.includes("@")) {
      toast.error("Please enter a valid email");
      return;
    }
    toast.success("You're subscribed! Watch your inbox for updates.");
    setEmail("");
  };

  return (
    <section className="bg-[#26395F] text-white border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-16 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
        <div>
          <h2 className="font-display text-4xl tracking-tight">Stay in the loop.</h2>
          <p className="text-white/60 mt-2">Get service updates, setup tips, and one-time offers in your inbox.</p>
        </div>
        <form onSubmit={submit} className="flex w-full max-w-md gap-3">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="flex-1 rounded-full bg-white/10 border border-white/15 px-5 py-3 outline-none focus:border-[#3B82F6] transition-colors placeholder:text-white/40"
            data-testid="newsletter-input"
          />
          <button type="submit" className="btn-sweep bg-[#3B82F6] text-[#0F172A] font-bold px-6 py-3 rounded-full hover:glow-primary transition-shadow duration-300" data-testid="newsletter-submit">
            Subscribe
          </button>
        </form>
      </div>
    </section>
  );
}
